import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';

import { RequestInProgressService }  from '@trivelope/triv-ui-tools-lib';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';

import { Section } from 'src/app/classes/section';
import { SectionService } from 'src/app/services/section.service';

import { Environment } from 'src/app/classes/environment';


@Component({
	selector: 'app-section-editor',
	templateUrl: './section-editor.component.html',
	styleUrls: ['./editor.component.css']
})
export class SectionEditorComponent implements OnInit {

	private _section: Section = new Section();
	@Input() set section( val: Section ) {
		this._section = val;
		this.updateValueForm();
	}
	get section() {
		return this._section;
	}
	formG1: UntypedFormGroup = this._fb.group({});
	myInputs: { [name: string]: DataInput } = {};

	@Output() done = new EventEmitter<Section>();

	constructor(
		@Inject(RequestInProgressService) public requestInProgressService: RequestInProgressService,
		private _fb: UntypedFormBuilder,
		private sectionService: SectionService,
		@Inject('environment') private environment: Environment,
	) {}

	ngOnInit() {

		for( let dataInput of this.environment.section ) {
			this.myInputs[ dataInput.id ] = dataInput;
		}

		setTimeout( () => {
			this.updateValueForm();
		}, 1 );
	}

	updateValueForm() {

		if( this.formG1.get( 'sparteBeshreibung') ) {	// the formgroup is already initialized
			this.formG1.reset();
			this.formG1.patchValue( this._section );
		}
	}

	cancel() {
		this.done.emit( new Section() );
	}

	reset() {
		console.log( 'reset()', this.formG1 )
		this.updateValueForm();
	}

	save() {

		const elementToSave = { ...this._section };

		const f = this.formG1.value;
		for( const field in this.myInputs ) {
			(elementToSave[ field as keyof Section ] as any) = f[ field ];
		}

		if( !this._section.sparteId ) {
			this.sectionService.create( elementToSave ).subscribe( elementSaved => {
				if( elementSaved.sparteId ) {
					for( const property in elementSaved ) {
						if (elementSaved.hasOwnProperty(property)) {
							this._section[ property ] = elementSaved[ property ];
						}
					}
					this.done.emit(this._section);
				}
			});
		}
		else {
			this.sectionService.update( elementToSave ).subscribe( b => {
				if( b ) {
					for( const property in elementToSave ) {
						if (elementToSave.hasOwnProperty(property)) {
							this._section[ property ] = elementToSave[ property ];
						}
					}
					this.done.emit(this._section);
				}
			});
		}


	}
}
